import { useNavigate } from "react-router-dom";
import { useModals } from '@mattjennings/react-modal-stack';
import BusModal from '../screens/BusModal';
import DriverModal from '../screens/DriverModal';

import Calendar from "./Calendar";
import { dateToTimestamp } from "../util";

const today = new Date();


function stringToColor(str, s1 = 45, l1 = 40, s2 = 40, l2 = 35) {
    // Simple hash function
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }

    // Convert the hash to a hue value between 0 and 360
    const hue = theCorrectMod(hash, 360);

    // Return the CSS color format
    return [
        `hsl(${hue}, ${s1}%, ${l1}%)`,
        `hsl(${hue}, ${s2}%, ${l2}%)`,
    ];
}

function formatTime(minutes) {
    if(minutes == 0) return "-";
    const remainder = minutes % 60;
    const hours = (minutes - remainder) / 60;

    let str = "";
    if(hours != 0) str += hours + " h";
    if(remainder != 0) str += " " + remainder + " min";
    return str;
}

function sameDay(d1, d2) {
    return d1.getFullYear() === d2.getFullYear() &&
      d1.getMonth() === d2.getMonth() &&
      d1.getDate() === d2.getDate();
}

function dayInArrangement(row, date) {
    // row["arrangement_start"] is of type string('yyyy-mm-dd')
    // convert it to Date, time of day is irrelevant
    const start = new Date(row["arrangement_start"] + "T00:00:00");
    const end = new Date(row["arrangement_end"] + "T00:00:00");

    console.log("Comparing: ", "start:", start, "end:", end, "date:", date);
    console.log("Timestamps: ", "start:", start.getTime(), "end:", end.getTime(), "date:", date.getTime());

    if(start > date.getTime()) return false;
    if(end < date.getTime()) return false;

    const weekday = date.getDay();

    if(row["arrangement_on_sunday"] && weekday == 0) return true;
    if(row["arrangement_on_monday"] && weekday == 1) return true;
    if(row["arrangement_on_tuesday"] && weekday == 2) return true;
    if(row["arrangement_on_wednesday"] && weekday == 3) return true;
    if(row["arrangement_on_thursday"] && weekday == 4) return true;
    if(row["arrangement_on_friday"] && weekday == 5) return true;
    if(row["arrangement_on_saturday"] && weekday == 6) return true;

    return false;
}

function theCorrectMod(v, n) {
    return ((v % n) + n) % n;
}

// Takes in strictly "hh:mm" format string
function hhmmToDate(str) {
    return new Date(`1970-01-01T${str}Z`);
}

function dateToYYYYMMDD(date) {
    return `${date.getFullYear()}-${(""+(date.getMonth()+1)).padStart(2, "0")}-${(""+date.getDate()).padStart(2, "0")}`;
}



function AdminCalendar({ jobs, arrangements, arrangementExceptions, showJobs = true, showArrangements = true }) {
    const navigate = useNavigate();
    const { openModal } = useModals();

    function DayRenderer({ date }) {
        let elements = [];

        showJobs && jobs.forEach(row => {
            const startDate = new Date(row["query_start"]*1000);

            if(!sameDay(startDate, date)) return;

            const [ color1, color2 ] = row["driver_id"] ? stringToColor(row["driver_firstname"], 60, 85, 60, 60) : [];
            const [ bg, border, color ] = row["driver_id"] ? [ color1, "1px solid "+color2, '#000' ] : [ 'white', '1px dashed #aaa', '#000' ];

            elements.push({

                time: startDate.getTime(),

                element: (
                    <div className="column" style={{ paddingInline: 4, border: border, backgroundColor: bg, color }}>
                        <div className="row">
                            <p style={{ flex: 1 }}>{`${(""+startDate.getHours()).padStart(2, "0")}:${(""+startDate.getMinutes()).padStart(2, "0")}`}</p>
                            { row["driver_id"] ? (
                                <button style={{ color, fontSize: 12 }} className="borderless" onClick={() => navigate("/platform/job/" + row["query_id"])}>Ava</button>
                            ) : (
                                <button style={{ color, fontSize: 12 }} className="borderless" onClick={() => navigate("/platform/confirmedQuery/" + row["query_id"])}>Ava</button>
                            ) }
                        </div>

                        { row["driver_id"] ? (
                            <p style={{ fontSize: 12 }}><a className="default" onClick={() => openModal(DriverModal, { id: row["driver_id"] })}>{row["driver_firstname"]}</a> • <a className="default" onClick={() => openModal(BusModal, { id: row["bus_id"] })}>{row["bus_name"]}</a></p>
                        ) : (
                            <i style={{ fontSize: 12, color: '#666' }}>Määra buss ja juht</i>
                        ) }

                    </div>
                ),

            });
        });

        showArrangements && arrangements?.forEach(row => {
            if(!dayInArrangement(row, date)) return null;

            const [bg1, bg2] = stringToColor(row["arrangement_name"]+"4sava", 40, 90, 40, 83);
            const color = '#000';

            const exception = arrangementExceptions.find(
                exception => row["arrangement_id"] == exception["arrangement_id"]
                    && sameDay(date, new Date(exception["arrangement_exception_exception_date"]))
            );

            if(exception) {

                // Display exception
                elements.push({

                    time: date.getTime() + hhmmToDate(exception["arrangement_exception_depart"]).getTime(),

                    element: (
                        <div className="column" style={{ paddingInline: 4, border: '1px solid #aaa', color, backgroundImage: `linear-gradient(135deg, ${bg1} 25%, ${bg2} 25%, ${bg2} 50%, ${bg1} 50%, ${bg1} 75%, ${bg2} 75%, ${bg2} 100%)`, backgroundSize: '40.00px 40.00px' }}>

                            <div className="row">
                                <p style={{ flex: 1 }}>{exception["arrangement_exception_depart"]}</p>
                                <button style={{ color, fontSize: 12 }} className="borderless" onClick={() => navigate("/platform/arrangement/" + row["arrangement_id"] + "?date=" + dateToYYYYMMDD(date))}>Ava</button>
                            </div>

                            <p style={{ fontSize: 12, color }}><a className="default" onClick={() => navigate("/platform/arrangement/" + row["arrangement_id"] + "?date=" + dateToYYYYMMDD(date))}>{row["arrangement_name"]}</a> • <a className="default" onClick={() => openModal(DriverModal, { id: exception["driver_id"] })}>{exception["driver_firstname"]}</a></p>

                        </div>
                    ),

                });

            } else {

                // [{"driverId": "057B4F508B9511EFA812F9F59D57FE0A", "driverName": "Priit", "changedAt": "2025-08-19"}]
                const previousDrivers = row["arrangement_previous_drivers"] ? JSON.parse(row["arrangement_previous_drivers"]) : [];

                // Sort previous drivers by date (newest first) to find the first applicable change
                const sortedPreviousDrivers = previousDrivers.sort((a, b) => new Date(b.changedAt) - new Date(a.changedAt));

                // Find the driver who was active at this date
                let driverId = row["driver_id"];
                let driverName = row["driver_firstname"];

                for (const prevDriver of sortedPreviousDrivers) {
                    const cellDateStr = dateToYYYYMMDD(date);

                    // If the change happened after this date, this previous driver was active
                    if (prevDriver.changedAt > cellDateStr) {
                        driverId = prevDriver.driverId;
                        driverName = prevDriver.driverName;
                    } else {
                        // Stop at first change that happened on or before this date
                        break;
                    }
                }

                // Display ordinary arrangement, no exception for this date
                elements.push({

                    time: date.getTime() + hhmmToDate(row["arrangement_depart"]).getTime(),

                    element: (
                        <div className="column" style={{ paddingInline: 4, border: '1px solid #aaa', color, backgroundImage: `linear-gradient(135deg, ${bg1} 25%, ${bg2} 25%, ${bg2} 50%, ${bg1} 50%, ${bg1} 75%, ${bg2} 75%, ${bg2} 100%)`, backgroundSize: '40.00px 40.00px' }}>

                            <div className="row">
                                <p style={{ flex: 1 }}>{row["arrangement_depart"]}</p>
                                <button style={{ color, fontSize: 12 }} className="borderless" onClick={() => navigate("/platform/arrangement/" + row["arrangement_id"] + "?date=" + dateToYYYYMMDD(date))}>Ava</button>
                            </div>

                            <p style={{ fontSize: 12, color }}><a className="default" onClick={() => navigate("/platform/arrangement/" + row["arrangement_id"])}>{row["arrangement_name"]}</a> • <a className="default" onClick={() => openModal(DriverModal, { id: driverId })}>{driverName}</a></p>

                        </div>
                    ),

                });

            }
        });

        elements.sort((a, b) => a.time - b.time);

        return (
            <div className="column g4">
                { elements.map(e => e.element) }
            </div>
        )
    }

    return <Calendar DayRenderer={DayRenderer} />
};

export default AdminCalendar;